import { useId, useState } from "react";
import { ChevronDown } from "lucide-react";
import { EXECUTIVE_HOURS, PLANS, formatBRL } from "@/data/plans";
import type { UnitSlug } from "@/data/units";
import { track } from "@/lib/tracking";

/** Tabela editorial com todos os planos de uma unidade. */
export function PlansTable({ slug }: { slug: UnitSlug }) {
  const { plans, note } = PLANS[slug];
  const [open, setOpen] = useState(false);
  const panelId = useId();
  const hasExecutive = plans.some((p) => p.executive);

  return (
    <div>
      <ul className="divide-y divide-border border-y border-border">
        {plans.map((p) => (
          <li
            key={p.id}
            className="grid grid-cols-[1fr_auto] items-baseline gap-x-6 gap-y-1 py-5 sm:grid-cols-[1.2fr_1fr_auto] sm:py-6"
          >
            <span className="text-[0.78rem] font-semibold uppercase tracking-[0.16em] text-foreground">
              {p.name}
            </span>
            <span className="text-right sm:order-3">
              <span className="display text-2xl text-foreground sm:text-3xl">{formatBRL(p.monthly)}</span>
              <span className="ml-1 text-xs text-muted-foreground">/mês</span>
            </span>
            <span className="col-span-2 text-xs text-muted-foreground sm:order-2 sm:col-span-1">
              {p.executive ? (
                <button
                  type="button"
                  aria-controls={panelId}
                  aria-expanded={open}
                  onClick={() => {
                    if (!open) track("executive_hours_open", { unit: slug, plan: p.id, source_section: "unit_plans" });
                    setOpen((v) => !v);
                  }}
                  className="inline-flex min-h-6 items-center gap-1 text-nook-green underline-offset-4 hover:underline"
                >
                  Ver horários
                  <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} aria-hidden="true" />
                </button>
              ) : (
                p.period
              )}
            </span>
          </li>
        ))}
      </ul>

      {hasExecutive && (
        <div id={panelId} hidden={!open} className="mt-6 rounded-sm border border-border bg-card p-6">
          <p className="eyebrow">Horários do Executivo</p>
          <p className="mt-3 text-sm text-foreground">{EXECUTIVE_HOURS.days}</p>
          <ul className="mt-3 flex flex-wrap gap-2">
            {EXECUTIVE_HOURS.slots.map((s) => (
              <li key={s} className="rounded-sm border border-border px-3 py-1.5 text-xs text-muted-foreground">
                {s}
              </li>
            ))}
          </ul>
        </div>
      )}

      {note && <p className="mt-6 text-xs text-muted-foreground">{note}</p>}
    </div>
  );
}
